import { render } from "./TierDetail.vue?vue&type=template&id=d99930ce&scoped=true"
import script from "./TierDetail.vue?vue&type=script&lang=js"
export * from "./TierDetail.vue?vue&type=script&lang=js"

import "./TierDetail.vue?vue&type=style&index=0&id=d99930ce&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d99930ce"]])

export default __exports__